/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Tue Feb 11 2025
 **/
import { MouseEvent, ChangeEvent } from "react";

import { Utility } from "@/frameworks/libraries/utilities";

import Header from "./Header";
import HeaderMobile from "./HeaderMobile";

export type ViewerHeaderProps = {
	createByID: string;
	fileName: string;
	publisherName: string;
	date?: number;
	fileDisplaySize?: string;
	mimeType: string;
	minimize?: boolean;
	onClickClose?: (e: MouseEvent<HTMLButtonElement>) => void;
	onClickDownload?: (e: MouseEvent<HTMLButtonElement>) => void;
	onClickDelete?: (e: MouseEvent<HTMLButtonElement>) => void;
	onClickMinimize?: () => void;
	onInputRangeChange?: (e: ChangeEvent<HTMLInputElement>) => void;
};

export default function HeaderWrapper(props: ViewerHeaderProps) {
	return <>{Utility.isMobile ? <HeaderMobile {...props} /> : <Header {...props} />}</>;
}
